module.exports = __webpack_public_path__ + "static/media/icon_mesh_off.9f547002.svg";